module.exports = __webpack_public_path__ + "img/low hips.262dcf95.png";